import { ThreeBounce } from 'better-react-spinkit';
import React from 'react';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { Box, BoxProps } from '../box';
import { Typography } from '../typography';

interface LoadingSpinnerProps extends BoxProps {
  text?: string;
  children?: React.ReactNode;
}

export function LoadingSpinner({ text, children, ...boxProps }: LoadingSpinnerProps) {
  return (
    <Box flexDirection="column" alignItems="center" justifyContent="center" width="100%" {...boxProps}>
      <Loader size={24} />

      {text && (
        <Typography $my={2} $fontSize={3} $fontWeight={500} $color={theme.colors.primaryLight}>
          {text}
        </Typography>
      )}

      {children}
    </Box>
  );
}

const Loader = styled(ThreeBounce)`
  & > div {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }
`;
